import { render, staticRenderFns } from "./recurring-credits-tab.vue?vue&type=template&id=b63eb988&scoped=true"
import script from "./recurring-credits-tab.vue?vue&type=script&lang=js"
export * from "./recurring-credits-tab.vue?vue&type=script&lang=js"
import style0 from "./recurring-credits-tab.vue?vue&type=style&index=0&id=b63eb988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63eb988",
  null
  
)

export default component.exports